(function (root, factory) {
  root.GreenfieldAnchorMatchEngine = factory();
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  const LOGIC_VERSION = 'anchor-match-beta-2026-07-17.3';

  const FAMILY_META = {
    mushroom: {
      label: 'Mushroom',
      line: 'Simple holding for a PWC, kayak, canoe, or very small boat.',
      use: 'Small craft in calm water and soft bottoms.',
      alternative: 'fluke',
      sourceRuleIds: ['GF-FAMILY-MUSHROOM', 'GF-CHART-MUSHROOM'],
    },
    fluke: {
      label: 'Fluke',
      line: 'The straightforward choice for sand and firm mud.',
      use: 'Lakes, bays, and coves with sand or firm mud.',
      alternative: 'richter',
      sourceRuleIds: ['GF-FAMILY-FLUKE', 'GF-CHART-FLUKE', 'GF-CHAIN-FLUKE'],
    },
    river: {
      label: 'River',
      line: 'Made for current, pontoons, and places where the anchor can grab.',
      use: 'Rivers, current, structure, and many pontoon setups.',
      alternative: 'richter',
      sourceRuleIds: ['GF-FAMILY-RIVER', 'GF-CHART-RIVER'],
    },
    richter: {
      label: 'Richter',
      line: 'The versatile choice when the bottom changes or you are not sure.',
      use: 'Rock, weeds, mixed bottoms, or unfamiliar water.',
      alternative: 'fluke',
      sourceRuleIds: ['GF-FAMILY-RICHTER', 'GF-CHART-RICHTER'],
    },
  };

  const LENGTHS = {
    under_16: { label: 'Under 16 ft', representative: 14, max: 16 },
    ft_16_20: { label: '16–20 ft', representative: 18, max: 20 },
    ft_21_22: { label: '21–22 ft', representative: 22, max: 22 },
    ft_23_26: { label: '23–26 ft', representative: 25, max: 26 },
  };

  function recommend(answers) {
    const boat = answers.boat_type;
    const length = LENGTHS[answers.length_band] || LENGTHS.ft_16_20;
    const bottom = answers.bottom;
    let family = 'richter';
    const reasons = [];
    const cautions = [];

    if (bottom === 'river_current') {
      family = 'river';
      reasons.push('RIVER_OR_CURRENT');
    } else if (bottom === 'rock_weeds_mixed' || bottom === 'unknown') {
      family = 'richter';
      reasons.push(bottom === 'unknown' ? 'BOTTOM_UNKNOWN' : 'CHANGING_BOTTOM');
    } else if (bottom === 'sand_mud' && boat === 'pwc_paddle' && answers.length_band === 'under_16') {
      family = 'mushroom';
      reasons.push('SMALL_CRAFT');
    } else if (bottom === 'sand_mud') {
      family = 'fluke';
      reasons.push('SAND_OR_MUD');
    }

    if (boat === 'pontoon' && bottom === 'rock_weeds_mixed') {
      family = 'river';
      reasons.push('PONTOON');
    }
    if (answers.length_band === 'ft_23_26') {
      reasons.push('CURRENT_ONLINE_RANGE');
      cautions.push('EXACT_SIZE_REVIEW');
    }
    if (bottom === 'unknown') cautions.push('BOTTOM_UNKNOWN');
    if (['fluke', 'river', 'richter'].includes(family)) cautions.push('EXACT_SIZE_REVIEW');
    if (family === 'fluke') cautions.push('CHAIN_NEEDED');

    let purchase = answers.gear === 'anchor_only' ? 'anchor' : 'kit';
    if (answers.gear === 'unsure') {
      reasons.push('GEAR_UNSURE');
      cautions.push('GEAR_UNSURE_KIT_RECOMMENDED');
    }
    if (family === 'mushroom' && answers.gear !== 'anchor_only') {
      purchase = 'anchor';
      reasons.push('COMPLETE_SETUP_REQUESTED');
      cautions.push('COMPLETE_KIT_UNAVAILABLE');
      const kitCaution = cautions.indexOf('GEAR_UNSURE_KIT_RECOMMENDED');
      if (kitCaution !== -1) cautions.splice(kitCaution, 1);
    }
    const alternative = FAMILY_META[family].alternative;

    return {
      status: 'family_only',
      logic_version: LOGIC_VERSION,
      primary_family: family,
      alternative_family: alternative,
      recommended_purchase: purchase,
      source_rule_ids: FAMILY_META[family].sourceRuleIds,
      matched_reason_codes: [...new Set(reasons)],
      caution_codes: [...new Set(cautions)],
      boat_length: length,
      answers: Object.assign({}, answers),
    };
  }

  return {
    LOGIC_VERSION,
    FAMILY_META,
    LENGTHS,
    recommend,
  };
});
